<template>
  <tinymce-editor :init="tinymceSettings"
                  :value="value"
                  @input="handleInput"/>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/themes/mobile'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/link'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/paste'
import TinymceEditor from '@tinymce/tinymce-vue'
import {
  DEFAULT_LINE_HEIGHT,
  DEFAULT_FONT_FAMILY,
  DEFAULT_FONT_SIZE,
  sanitizeTypographyStyles,
} from '../helpers/sanitize_typography_styles'

const defaultEditorContentStyles = `
  html body.mce-content-body,
  html body.mce-content-body p,
  html body.mce-content-body div,
  html body.mce-content-body span,
  html body.mce-content-body ol,
  html body.mce-content-body ul,
  html body.mce-content-body li {
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: ${DEFAULT_FONT_SIZE};
    line-height: ${DEFAULT_LINE_HEIGHT} !important;
  }
  html body.mce-content-body [style*="font-family"],
  html body.mce-content-body [style*="font-size"] {
    font-family: ${DEFAULT_FONT_FAMILY} !important;
    font-size: ${DEFAULT_FONT_SIZE} !important;
  }
  html body.mce-content-body p {
    margin: 0 0 14px 0;
  }
  html body.mce-content-body ol,
  html body.mce-content-body ul {
    margin-bottom: 14px;
  }
  html body.mce-content-body li {
    margin-bottom: 4px;
  }
`

export default {
  name: 'prk-editor',
  components: { TinymceEditor },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      tinymceSettings: {
        content_style: defaultEditorContentStyles,
        content_css: '/tinymce/skins/content/default/content.css',
        skin_url: '/tinymce/skins/ui/oxide/',
        height: 150,
        plugins: 'autoresize code lists advlist link table paste',
        paste_as_text: true,
        toolbar: 'code | bold italic underline hr forecolor backcolor | link unlink | undo redo | \n' +
            '            bullist numlist | outdent indent | alignleft aligncenter | alignright alignjustify |',
        menubar: 'tools insert edit table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        branding: false,
        statusbar: false,
        invalid_elements: 'script',
        setup: editor => {
          editor.on('BeforeSetContent', event => {
            event.content = this.sanitizeContent(event.content)
          })
          editor.on('GetContent', event => {
            event.content = this.sanitizeContent(event.content)
          })
        },
      },
    }
  },
  methods: {
    handleInput (content) {
      this.$emit('input', this.sanitizeContent(content))
    },
    sanitizeContent (content) {
      return sanitizeTypographyStyles(content)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/vars';

</style>
